import React, { Component } from 'react';
import { getImage } from '../utils';
import { _Queue } from './models';

type Props = {
  historyList: _Queue[];
  conversationHistory?: string;
};
type State = {};

export default class QueueHistory extends Component<Props, State> {
  getHistoryIcon(type: string): string {
    switch (type) {
      case 'handoff':
        return 'flag.svg';
      case 'transfer':
      case 'release':
        return 'transfer.svg';
      case 'start':
        return 'message-red.svg';
      default:
        return '';
    }
  }

  getHistoryText(type: string, time: string, sentBy?: string, chatType?: string) {
    switch (type) {
      case 'handoff':
        return (
          <div className='queue'>
            <div>Handoff</div>
            <div className='timestamp'>{time}</div>
          </div>
        );
      case 'transfer':
        return (
          <div className='queue'>
            <div>
              Chat transferred to <strong>{chatType}</strong> by{' '}
              <div className='sender'>{sentBy}</div>
            </div>
            <div className='timestamp'>{time}</div>
          </div>
        );
      case 'release':
        return (
          <div className='queue'>
            <div>
              Chat released back to <strong>{chatType}</strong> by{' '}
              <div className='sender'>{sentBy}</div>
            </div>
            <div className='timestamp'>{time}</div>
          </div>
        );
      case 'start':
        return (
          <div className='queue'>
            <div>
              Chat started by <div className='sender'>{sentBy}</div>
            </div>
            <div className='timestamp'>{time}</div>
          </div>
        );
      default:
        return <div></div>;
    }
  }

  render() {
    return (
      <div
        id={`${
          this.props.conversationHistory !== 'true'
            ? 'history-content-wrapper'
            : 'content-history-wrapper'
        }`}>
        {this.props.historyList.map((history, index) => {
          return (
            <div key={index} className='queue-details'>
              <div>
                <img
                  src={getImage(this.getHistoryIcon(history.type))}
                  alt={history.type}
                />
                {this.getHistoryText(
                  history.type,
                  history.time,
                  history.sentBy,
                  history.chatType
                )}
              </div>
              {history.comment ? (
                <div className='comment'>
                  <img src={getImage('comment.svg')} alt='comment' />
                  <div style={{ wordBreak: 'break-all' }}>{history.comment}</div>
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    );
  }
}
